import { ILocalizedError } from '@localina/core';
import { useMutation, UseMutationOptions, useQueryClient } from '@tanstack/react-query';
import { LocalinaApiContext } from '../../../index';
import { downloadFile } from '../../utils';
import { useRestaurantId } from '../../utils/RestaurantUtils';
import { queryKeys } from './query-keys';

const useUploadDocument = (options?: UseMutationOptions<string, ILocalizedError, { document: File }>) => {
    const queryClient = useQueryClient();
    const restaurantId = useRestaurantId();

    return useMutation({
        mutationFn: saveRestaurantLogoMutationFn(restaurantId),
        onSuccess: () => queryClient.invalidateQueries(queryKeys.restaurants.all),
        ...options,
    });
};

const useDownloadDocument = (
    options?: UseMutationOptions<
        { blob: Blob; fileName: string },
        ILocalizedError,
        {
            path: string;
        }
    >,
) => {
    const restaurantId = useRestaurantId();

    return useMutation({
        mutationFn: (variables) => {
            return LocalinaApiContext.serviceApi.getRestaurantDocument(restaurantId, variables.path);
        },
        onSuccess: (data) => {
            downloadFile(data.blob, data.fileName);
        },
        ...options,
    });
};

const saveRestaurantLogoMutationFn = (restaurantId: string) => (variables: { document: File }) =>
    LocalinaApiContext.serviceApi.saveRestaurantDocument(restaurantId, variables.document);

export { useUploadDocument, useDownloadDocument };
